<script lang="ts" setup>
const router = useRouter();
router.replace({ name: '/errors/404' });
</script>
